import { MenuProps } from "antd";
import { BarChartBig, BookCheck, Boxes, CalendarClock, Landmark, Sword, Users, ClipboardList, LayoutDashboard, Mail, Video } from "lucide-react";
import { Translation } from "react-i18next";
import { Link } from "react-router-dom";
import { User, TenantSettings } from "@types";
import { getKeycloakRealm } from "@/components/helpers";

export const navbarItems = (user: User, tenantSettings?: TenantSettings): MenuProps["items"] => {
    const items: MenuProps["items"] = [];
        const hasAdminRole = user.applicationRoles.some((role) => role.name === "Admin");

    if (user.applicationRoles.some((role) => role.name === "TermAdmin") && user.applicationRoles.some((role) => role.name === "ExamAdmin")) {
        items.push({
            label: <Link to={`/${getKeycloakRealm}/`}><Translation>{t => t("navbar.dashboard")}</Translation></Link>,
            key: "dashboard",
            icon: <LayoutDashboard/>
        });
        items.push({
            label: <Link to={`/${getKeycloakRealm}/exams`}><Translation>{t => t("exams")}</Translation></Link>,
            key: "home",
            icon: <BookCheck/>
        });
        items.push({
            label: <Link to={`/${getKeycloakRealm}/exam-periods`}><Translation>{t => t("examPeriods")}</Translation></Link>,
            key: "exam-periods",
            icon: <CalendarClock/>
        });
       
    } else if (user.applicationRoles.some((role) => role.name === "TermAdmin")) {

        items.push({
            label: <Link to={`/${getKeycloakRealm}/exam-periods`}><Translation>{t => t("examPeriods")}</Translation></Link>,
            key: "exam-periods",
            icon: <CalendarClock/>
        });
    } else if (user.applicationRoles.some((role) => role.name === "ExamAdmin")) {
        items.push({
            label: <Link to={`/${getKeycloakRealm}/`}><Translation>{t => t("navbar.dashboard")}</Translation></Link>,
            key: "dashboard",
            icon: <LayoutDashboard/>
        });
        items.push({
            label: <Link to={`/${getKeycloakRealm}/exams`}><Translation>{t => t("exams")}</Translation></Link>,
            key: "home",
            icon: <BookCheck/>
        });
    }

    if (user.applicationRoles.some((role) => role.name === "QuestionAdmin")) {
        items.push({
            label: <Link to={`/${getKeycloakRealm}/bank-pool`}><Translation>{t => t("bankPool")}</Translation></Link>,
            key: "bank-pool",
            icon: <Landmark/>
        });
        if (!tenantSettings?.disableQuizWizard) {
            items.push({
                label: <Link to={`/${getKeycloakRealm}/quiz-wizard`}><Translation>{t => t("quizWizard")}</Translation></Link>,
                key: "quiz-wizard",
                icon: <Sword/>
            });
        }
    }
        if (hasAdminRole) {
        items.push({
            label: <Link to={`/${getKeycloakRealm}/reports`}><Translation>{t => t("reports")}</Translation></Link>,
            key: "reports",
            icon: <BarChartBig/>
        });
    }
    if (user.applicationRoles.some((role) => role.name === "Assessor")) {
        items.push({
            label: <Link to={`/${getKeycloakRealm}/grading/pending-corrections`}><Translation>{t => t("grading.pendingCorrections")}</Translation></Link>,
            key: "pending-corrections",
            icon: <ClipboardList/>
        });
    }
    if (user.applicationRoles.some((role) => role.name && ["Assessor", "Admin", "TermAdmin"].includes(role.name))) {
        items.push({
            label: <Link to={`/${getKeycloakRealm}/proctoring`}><Translation>{t => t("proctoring.menu")}</Translation></Link>,
            key: "proctoring",
            icon: <Video/>
        });
    }
    if (user.applicationRoles.some((role) => role.name === "Admin")) {
        items.push({
            label: <Link to={`/${getKeycloakRealm}/categories`}><Translation>{t => t("categories")}</Translation></Link>,
            key: "categories",
            icon: <Boxes/>
        });
        items.push({
            label: <Link to={`/${getKeycloakRealm}/users`}><Translation>{t => t("users")}</Translation></Link>,
            key: "users",
            icon: <Users/>
        });
        items.push({
            label: <Link to={`/${getKeycloakRealm}/email-templates`}><Translation>{t => t("emailTemplates")}</Translation></Link>,
            key: "email-templates",
            icon: <Mail/>
        });
    }
    return items;
}